import { StatistiquesPath } from 'src/app/pages/statistiques/statistiques-path';
import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const exportBpfSousMenuItem = new SousMenuItemAggregate(
    'Audit BPF',
    `/${EparcoursPath.root.TDB}/${StatistiquesPath.BPF}`,
    new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ExportBPF)]),
);

export const statistiquesSousMenuItem = new SousMenuItemAggregate(
    'Tableaux de bord',
    `/${EparcoursPath.root.TDB}`,
    new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Statistiques)]),
);
